import ImgDarenElder from "../images/daeren-elder.svg";
import ImgRubyPerrin from "../images/ruby-perrin.svg";
import ImgPaulRichard from "../images/paul-richard.svg";
import ImgDeborahAngel from "../images/deborah-angel.svg";

const doctors = [
  {
    image: ImgDarenElder,
    name: "Darren Elder",
    special: "BDS, MDS - Oral & Maxillofacial Surgery",
    rate: 4,
    review: 35,
    location: "New York, USA",
    available: "Fri, 22 Mar",
    price: "$50 - $300",
  },
  {
    image: ImgRubyPerrin,
    name: "Ruby Perrin",
    special: "MDS - Periodontology and Oral Implantology, BDS",
    rate: 5,
    review: 17,
    location: "Florida, USA",
    available: "Fri, 22 Mar",
    price: "$300 - $1000",
  },
  {
    image: ImgPaulRichard,
    name: "Paul Richard",
    special: "MBBS, MD - Dermatology, Venereology & Lepros",
    rate: 4,
    review: 49,
    location: "California, USA",
    available: "Fri, 22 Mar",
    price: "$100 - $400",
  },
  {
    image: ImgDeborahAngel,
    name: "Deborah Angel",
    special: "MBBS, MD - General Medicine, DNB - Cardiology",
    rate: 4,
    review: 27,
    location: "Georgia, USA",
    available: "Fri, 22 Mar",
    price: "$100 - $400",
  },
  {
    image: ImgDarenElder,
    name: "Darren Elder",
    special: "BDS, MDS - Oral & Maxillofacial Surgery",
    rate: 4,
    review: 35,
    location: "New York, USA",
    available: "Fri, 22 Mar",
    price: "$50 - $300",
  },
];

export default doctors;
